export default __webpack_public_path__ + "static/media/info-icon.0e250469.svg";